import { FunctionComponent, h } from 'preact'
import { useContext, useMemo, useState } from 'preact/hooks'

import { TextInput } from 'components/ui'
import { TextArea as TextAreaType } from 'scripts/type'
import usePropValueChange from 'components/business/SurveyForm/Fields/hooks/usePropValueChange'
import { useHandlersWithRequired } from 'components/business/SurveyForm/Fields/hooks'

import FieldWrapper from '../components/FieldWrapper'
import { FieldCommonProps } from '../type'
import FieldsContext from '../fieldsContext'
import styles from './index.scss'

const TextField: FunctionComponent<FieldCommonProps> = (props) => {
  const { field, required, onFieldSubmit } = props
  const [value, setValue] = useState<string>('')
  const { isMultipleFields } = useContext(FieldsContext)!
  const { onNext } = useHandlersWithRequired(setValue, required, onFieldSubmit)
  const { placeholder } = field as TextAreaType
  usePropValueChange(props, () => setValue(''))

  const disabled = useMemo(() => {
    return required && value.trim().length === 0
  }, [required, value])

  const handleChange = (value: string) => {
    setValue(value)
    isMultipleFields && onNext()
  }

  const paddingBottom = useMemo(() => {
    if (isMultipleFields) {
      return 0
    }
    return 16
  }, [isMultipleFields])

  return (
    <FieldWrapper {...props} handlerProps={{ visible: true, disabled, onNext }}>
      {/* div.overflow-hidden 是为了解决 margin 重叠问题 */}
      <div className={styles.inputWrapper} style={{ paddingBottom }}>
        <TextInput value={value} onChange={handleChange} placeholder={placeholder} />
      </div>
    </FieldWrapper>
  )
}

export default TextField
